import api from './api';

export interface Categoria {
    id: number;
    nome: string;
    grupo: 'receita' | 'custo' | 'despesa' | 'despesa_financeira';
    pre_carregada: number;
    ativo: number;
}

export const categoriasService = {
    list: async (grupo?: string) => {
        const response = await api.get<Categoria[]>('/categorias', { params: { grupo } });
        return response.data;
    },
    create: async (data: Partial<Categoria>) => {
        const response = await api.post<Categoria>('/categorias', data);
        return response.data;
    },
    update: async (id: number, data: Partial<Categoria>) => {
        const response = await api.put<Categoria>(`/categorias/${id}`, data);
        return response.data;
    },
    delete: async (id: number) => {
        await api.delete(`/categorias/${id}`);
    }
};
